"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.find-index.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _interface = require("../interface");
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../../_utils/hooks/usePrefixCls");
var _excluded = ["size", "color", "className", "style"]; // GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
/* eslint-disable */
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PencileIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('icon');
  var size = props.size,
    color = props.color,
    className = props.className,
    customStyle = props.style,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var isFontSize = false;
  var isSize = false;
  if (typeof size === 'number') {
    isFontSize = true;
  } else {
    isSize = _interface.SizeTypes.findIndex(function (item) {
      return item === size;
    }) !== -1;
  }
  var classes = (0, _classnames.default)(prefixCls, prefixCls + '--' + 'pencile', (0, _defineProperty2.default)({}, 'size-' + size, isSize), className);
  var style = _objectSpread({
    color: color,
    fontSize: isFontSize ? size : undefined
  }, customStyle);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    ref: ref,
    className: classes,
    style: style
  }, restProps, {
    height: "16",
    width: "16",
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    height: "16",
    width: "16",
    fill: "currentColor",
    opacity: "0.01"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.6273 2.70696C11.0178 2.31643 11.651 2.31643 12.0415 2.70696L13.2937 3.9591C13.6842 4.34962 13.6842 4.98279 13.2937 5.37331L12.8227 5.84431C12.4322 6.23484 11.799 6.23484 11.4085 5.84431L10.1563 4.59217C9.7658 4.20165 9.7658 3.56848 10.1563 3.17796L10.6273 2.70696ZM2 11.7477C2 11.4826 2.10533 11.2282 2.29283 11.0407L7.79732 5.53529C8.18783 5.14471 8.82104 5.14469 9.21159 5.53523L10.4647 6.78835C10.8553 7.17889 10.8552 7.81211 10.4646 8.20262L4.95924 13.7071C4.77171 13.8946 4.51738 13.9999 4.25219 13.9999H3C2.44772 13.9999 2 13.5522 2 12.9999V11.7477Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
});
var _default = PencileIcon;
exports.default = _default;